import { Component, ChangeDetectionStrategy, signal, HostListener, inject, DestroyRef } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { NavigationService } from '../../../../core/services/navigation.service';
import { MobileMenuService } from '../../../../core/services/mobile-menu.service';
import { QuoteCtaDirective } from '../../../../core/directives/quote-cta.directive';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, QuoteCtaDirective],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private nav = inject(NavigationService);
  readonly menu = inject(MobileMenuService);

  isScrolled = signal(false);

  // Full nav — used by the mobile burger menu (keeps About us + Blog reachable)
  navLinks = [
    { label: 'About us',     path: '/about',        desktop: false },
    { label: 'Services',     path: '/services',     desktop: true  },
    { label: 'Destinations', path: '/destinations', desktop: true  },
    { label: 'Partners',     path: '/partners',     desktop: true  },
    { label: 'Blog',         path: '/blog',         desktop: false },
    { label: 'Contact',      path: '/contact',      desktop: true  }, // public since MV-378 (PRD §3.6)
  ];

  desktopNavLinks = this.navLinks.filter(l => l.desktop);

  constructor() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.menu.setOpen(false));
  }

  @HostListener('window:scroll')
  onScroll() { this.isScrolled.set(window.scrollY > 20); }

  onMobileTransitionEnd(ev: TransitionEvent): void {
    // Fires for every transitioned property on .navbar__mobile; gate on transform
    // to avoid spurious notifications when background/color etc. also animate.
    if (ev.propertyName === 'transform' && !this.menu.open()) {
      this.menu.notifyClosed();
    }
  }

  onLogoClick(event: Event): void {
    event.preventDefault();
    void this.nav.goHome();
  }
}
